module.exports = __webpack_public_path__ + "iconfont.svg?59a6aafed5f84c7f79593597482d6a13";


//////////////////
// WEBPACK FOOTER
// ./example/src/font/iconfont.svg
// module id = 16
// module chunks = 0